import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { Error as ErrorIcon } from '@mui/icons-material';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  errorMessageArea: {
    alignItems: 'center',
    display: 'flex',
    marginLeft: theme.spacing(0.75),
    marginTop: theme.spacing(0.95875),
  },
  errorIcon: {
    color: '#D32F2F',
    marginRight: theme.spacing(0.75),
  },
  errorLabel: {
    color: '#D32F2F',
    fontSize: theme.spacing(1.5),
    letterSpacing: theme.spacing(0.05),
    lineHeight: `${theme.spacing(2.5)}px`,
  },
}));

const UsageBarErrorMessage = ({ errorLabel }) => {
  const classes = useStyles();

  return (
    <Box className={classes.errorMessageArea}>
      <ErrorIcon className={classes.errorIcon} />
      <Typography variant="body2" className={classes.errorLabel}>
        {errorLabel}
      </Typography>
    </Box>
  );
};

UsageBarErrorMessage.propTypes = {
  errorLabel: PropTypes.string.isRequired,
};

export default UsageBarErrorMessage;
